import React, {useContext} from 'react';
import {AuthContext} from './AuthContext';

const NAVI_WHITELABEL_ID = 1;

export const isNaviWhitelabel = (whitelabelId) => (
    whitelabelId === null || String(whitelabelId) === '1'
);

export const getWhitelabelLabel = (whitelabelId, whitelabelName = '') => {
    if (whitelabelId === undefined || whitelabelId === '') return 'Unknown';

    const effectiveId = whitelabelId === null ? NAVI_WHITELABEL_ID : whitelabelId;
    const configuredName = typeof whitelabelName === 'string' ? whitelabelName.trim() : '';
    const name = configuredName || (isNaviWhitelabel(whitelabelId) ? 'Navi' : 'Whitelabel');

    return `#${effectiveId} ${name}`;
};

export const getWhitelabelTextColor = (backgroundColor) => {
    const match = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(backgroundColor || '');
    if (!match) return '#fff';

    const hex = match[1].length === 3
        ? match[1].split('').map((character) => character + character).join('')
        : match[1];
    const red = parseInt(hex.slice(0, 2), 16);
    const green = parseInt(hex.slice(2, 4), 16);
    const blue = parseInt(hex.slice(4, 6), 16);
    const brightness = (red * 299 + green * 587 + blue * 114) / 1000;

    return brightness > 160 ? '#212529' : '#fff';
};

const WhitelabelBadge = ({whitelabelId, whitelabel: suppliedWhitelabel, className = ''}) => {
    const auth = useContext(AuthContext);
    const isUnknown = whitelabelId === undefined || whitelabelId === '';
    const effectiveId = whitelabelId === null ? NAVI_WHITELABEL_ID : whitelabelId;
    const whitelabel = suppliedWhitelabel || auth?.whitelabelsById?.[String(effectiveId)];
    const label = getWhitelabelLabel(whitelabelId, whitelabel?.name);
    const primaryColor = whitelabel?.primary_color;
    const badgeStyle = isUnknown
        ? 'badge-secondary'
        : isNaviWhitelabel(whitelabelId) ? 'badge-primary' : 'badge-info';

    return (
        <span
            className={`badge ${badgeStyle} ${className}`.trim()}
            title={isUnknown ? 'Whitelabel is not available' : label}
            style={primaryColor ? {
                backgroundColor: primaryColor,
                color: getWhitelabelTextColor(primaryColor),
            } : undefined}
        >
            <span style={{
                display: 'inline-block',
                maxWidth: '160px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                verticalAlign: 'bottom',
                whiteSpace: 'nowrap',
            }}>
                {label}
            </span>
        </span>
    );
};

export default WhitelabelBadge;
